exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.id, ".success-modal__body {\n  text-align: center; }\n\n.success-modal .ion-android-happy:before {\n  font-size: 70px;\n  color: #37ced0;\n  margin: 20px 0; }\n\n.success-modal__title {\n  font-size: 20px; }\n\n.success-modal__buttons .button {\n  width: 170px;\n  display: block;\n  margin: 30px auto 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/containers/Auth/components/SuccessRegister.scss
// module id = 419
// module chunks = 0